import { put } from "@redux-saga/core/effects";
import axios from "axios";

import { PagesService } from "./../../../services/pages";
import { IErrorType } from "./../../types/errors.d";
import { deletePageFailure, deletePageSuccess } from "./../actionCreators";
import { DeletePageRequestActionType } from "./../types";

import { undo } from "./../../../helpers/undoable";

export function* deletePageSaga(action: DeletePageRequestActionType) {
    const {
        payload: { id, removeFields },
    } = action;

    try {
        yield PagesService.deletePage({ id, removeFields });
        yield put(deletePageSuccess({ id }));
    } catch (error) {
        yield put(undo(action));
        if (axios.isAxiosError(error))
            yield put(deletePageFailure({ errorType: IErrorType.AXIOS, data: error.response?.data }));
        else yield put(deletePageFailure({ errorType: IErrorType.NATIVE, data: error }));
    }
}
